export default __webpack_public_path__ + "static/media/git-missing-intergration.a636a154.svg";